<!-- 综合雨水情 -->
<template>
  <div class='monitor'>
    <div class="content">
      <!-- <div class="countryList">
          <div class="country">
              <span>行政区划：</span>
          </div>
          <div class="country">
              <span @click="setAllCheck()" :class="{ 'countryon': all }">全部</span>
          </div>
          <div class="country" v-for="(item,index) in towns" :key="index">
              <span @click="setListCheck(index, item.adcd)" :class="{ 'countryon': item.check }">{{item.adnm}}</span>
          </div>
      </div> -->
      <TownName ref="townlist" v-on:townadcd="townAdcd"></TownName>
      <div class="countryList">
          <div class="country">
              <span>站点类别：</span>
          </div>
          <div class="country" v-for="(item,index) in categoryOne" :key="index">
              <span @click="categoryChangeOne(index, item.value)" :class="{ 'categoryon': index==choosed }">{{item.label}}</span>
          </div>
      </div>
      <div class="yuliang" ref="yuliang">
        <div class="select">
          <span class="desc">站名:</span>
          <el-input @change="nameSelect" v-model="inputData" clearable placeholder="请输入站名"></el-input>
          <span id="select" @click="submitQuery">查询</span>
        </div>
        <div class="raintable">
            <u-table use-virtual :excess-rows="5" :row-height="48" v-loading="loading" ref="table" :data="tdata" border :max-height="height" @selection-change="handleCurrentChange" style="width: 100%;" :default-sort ="{prop:'rainYesterday',order:'descending'}">
                <u-table-column fixed type="index" label="序号" width="60" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.$index+1 }}</div>
                  </template>
                </u-table-column>
                <u-table-column  fixed align="center" header-align="center" prop="addvnm" label="乡镇" sortable min-width="90">
                </u-table-column>
                <u-table-column fixed align="center" header-align="center" prop="stnm" label="站名" sortable min-width="90">
                  <template slot-scope="scope">
                    <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                      <div class="overflowWarn">
                        <span style="cursor:pointer!important;">{{ scope.row.stationName }}</span>
                      </div>
                    </el-tooltip>
                  </template>
                </u-table-column>
                <u-table-column fixed  align="center" header-align="center" prop="type" label="站类@(报讯项目)" min-width="105" :render-header="renderheader">
                  <template slot-scope="scope" style="text-align:center">
                    <!-- {{ scope.row.type }}({{ scope.row.sttp }}) -->
                    <el-tooltip effect="dark" :content="scope.row.type + ' ' + (scope.row.sttp?(scope.row.sttp):'')" placement="top" class="item" popper-class="hiddenOverflow">
                      <span style="cursor:pointer!important;">{{ scope.row.type }}({{ scope.row.sttp }})</span>
                    </el-tooltip>
                  </template>
                </u-table-column>
                <!--1. 降雨量 -->
                <!-- 所有站 -->
                <u-table-column header-align="center" v-if="type==='all'" :key="1" label="降雨量(mm)">
                    <u-table-column align="center" header-align="center" label="昨日" min-width="55" :sortable='true' :sort-method="sortChange1">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainYesterday === undefined ">-</div>
                        <div v-else>{{ scope.row.rainYesterday_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="8时-现在" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainToday === undefined ">-</div>
                        <div v-else>{{ scope.row.rainToday_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="前一小时" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainOneHourBefore === undefined ">-</div>
                        <div v-else>{{ scope.row.rainOneHourBefore_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="近一小时" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainNow === undefined ">-</div>
                        <div v-else>{{ scope.row.rainNow_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 水库站 -->
                <u-table-column header-align="center" v-if="type==='reservior'" :key="1" label="降雨量(mm)">
                    <u-table-column align="center" header-align="center" label="昨日" min-width="55" :sortable='true' :sort-method="sortChange1">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainYesterday === undefined ">-</div>
                        <div v-else>{{ scope.row.rainYesterday_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="8时-现在" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainToday === undefined ">-</div>
                        <div v-else>{{ scope.row.rainToday_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="前一小时" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainOneHourBefore === undefined ">-</div>
                        <div v-else>{{ scope.row.rainOneHourBefore_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="近一小时" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainNow === undefined ">-</div>
                        <div v-else>{{ scope.row.rainNow_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 江河站 -->
                <u-table-column header-align="center" v-if="type==='river'" :key="1" label="降雨量(mm)">
                    <u-table-column align="center" header-align="center" label="昨日" min-width="55" :sortable='true' :sort-method="sortChange1">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainYesterday === undefined ">-</div>
                        <div v-else>{{ scope.row.rainYesterday_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="8时-现在" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainToday === undefined ">-</div>
                        <div v-else>{{ scope.row.rainToday_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="前一小时" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainOneHourBefore === undefined ">-</div>
                        <div v-else>{{ scope.row.rainOneHourBefore_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="近一小时" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.rainNow === undefined ">-</div>
                        <div v-else>{{ scope.row.rainNow_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 雨量站 -->
                <u-table-column header-align="center" v-if="type==='rain'" :key="Math.random()" label="降雨量(mm)">
                    <u-table-column align="center" header-align="center" prop="昨日雨量"  label="昨日" min-width="110" :sortable='true' :sort-method="sortChange1">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.data && scope.row.data['昨日雨量'] === undefined ">-</div>
                        <div v-else>{{ scope.row.data?scope.row.data['昨日雨量']:'' }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="8时-现在"  label="8时-现在" min-width="110" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.data && scope.row.data['8时-现在'] === undefined ">-</div>
                        <div v-else>{{ scope.row.data? scope.row.data['8时-现在']:'' }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="近一小时" label="近一小时" min-width="110" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.data && scope.row.data['近一小时'] === undefined ">-</div>
                        <div v-else>{{ scope.row.data?scope.row.data['近一小时']:'' }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column header-align="center" label="今日">
                      <u-table-column
                        v-for="(item, index) in hoursOfToday"
                        :key="index"
                        align="center"
                        header-align="center"
                        :prop="item"
                        :label="item + '时'"
                        min-width="90"
                        sortable
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.data && scope.row.data[item] === undefined ">-</span>
                          <span v-else>{{scope.row.data?scope.row.data[item]:'' }}</span>
                        </template>
                      </u-table-column>
                    </u-table-column>
                    <u-table-column header-align="center" label="昨日">
                      <u-table-column
                        v-for="(item, index) in hoursOfYesterday"
                        :key="index"
                        align="center"
                        header-align="center"
                        :prop="item"
                        :label="item + '时'"
                        min-width="90"
                        sortable
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.data && scope.row.data[item] === undefined ">-</span>
                          <span v-else>{{scope.row.data? scope.row.data[item]:'' }}</span>
                        </template>
                      </u-table-column>
                    </u-table-column>
                </u-table-column>

                <!--2. 水位信息 -->
                <!-- 所有站 -->
                <u-table-column header-align="center" v-if="type==='all'" :key="2" label="水位信息">
                    <u-table-column align="center" header-align="center" prop="waterAtEight" label="8时水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.waterAtEight === undefined ">-</div>
                        <div v-else>{{ scope.row.waterAtEight_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="time"  label="当前水位时间" min-width="105" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="!scope.row.time">-</div>
                        <div v-else>{{ scope.row.time.slice(5) }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="water" label="当前水位@(m)" min-width="95" sortable :render-header="renderheader">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.water === undefined ">-</div>
                        <div v-else>{{ scope.row.water_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="waterStorage" label="当前库容@(万m³)" sortable min-width="95" :render-header="renderheader">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.waterStorage === undefined ">-</div>
                        <div v-else>{{ scope.row.waterStorage_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 水库站 -->
                <u-table-column header-align="center" v-if="type==='reservior'" :key="2" label="水位信息">
                    <u-table-column align="center" header-align="center" prop="waterAtEight" label="8时水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.waterAtEight === undefined ">-</div>
                        <div v-else>{{ scope.row.waterAtEight_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="time"  label="当前水位时间" min-width="95" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="!scope.row.time">-</div>
                        <div v-else>{{ scope.row.time.slice(5) }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="water" label="当前水位@(m)" min-width="95" :render-header="renderheader" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.water === undefined ">-</div>
                        <div v-else>{{ scope.row.water_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="waterStorage" label="当前库容@(万m³)" min-width="95" :render-header="renderheader" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.waterStorage === undefined ">-</div>
                        <div v-else>{{ scope.row.waterStorage_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 江河站 -->
                <u-table-column header-align="center" v-if="type==='river'" :key="2" label="水位信息">
                    <u-table-column align="center" header-align="center" prop="waterAtEight" label="8时水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.waterAtEight === undefined ">-</div>
                        <div v-else>{{ scope.row.waterAtEight_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="time"  label="当前水位时间" min-width="95" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="!scope.row.time">-</div>
                        <div v-else>{{ scope.row.time.slice(5) }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="water" label="当前水位@(m)" min-width="95" sortable :render-header="renderheader">
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.water === undefined ">-</div>
                        <div v-else>{{ scope.row.water_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>

                <!-- 3.特征水位 -->
                <!-- 所有站 -->
                <u-table-column header-align="center" v-if="type==='all'" :key="3" label="特征水位(m)">
                    <u-table-column align="center" header-align="center" prop="warningWater" label="警戒水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.warningWater === undefined ">-</div>
                        <div v-else>{{ scope.row.warningWater_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="guaranteeWater"  label="保证水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.guaranteeWater === undefined ">-</div>
                        <div v-else>{{ scope.row.guaranteeWater_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="limitedWater " label="汛限水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.limitedWater === undefined ">-</div>
                        <div v-else>{{ scope.row.limitedWater_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 水库站 -->
                <u-table-column header-align="center" v-if="type==='reservior'" :key="3" label="特征水位(m)">
                    <u-table-column align="center" header-align="center" prop="limitedWater " label="汛限水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.limitedWater === undefined ">-</div>
                        <div v-else>{{ scope.row.limitedWater_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" prop="guaranteeWater"  label="正常水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.guaranteeWater === undefined ">-</div>
                        <div v-else>{{ scope.row.guaranteeWater_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
                <!-- 江河站 -->
                <u-table-column header-align="center" v-if="type==='river'" :key="3" label="特征水位(m)">
                    <u-table-column align="center" header-align="center" label="警戒水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.warningWater === undefined ">-</div>
                        <div v-else>{{ scope.row.warningWater_Str }}</div>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" header-align="center" label="保证水位" min-width="65" sortable>
                      <template slot-scope="scope" style="text-align:center">
                        <div v-if="scope.row.guaranteeWater === undefined ">-</div>
                        <div v-else>{{ scope.row.guaranteeWater_Str }}</div>
                      </template>
                    </u-table-column>
                </u-table-column>
            </u-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import monitorTypes from '@/store/types/monitor'
import TownName from '@/components/Townname/index.vue'
import timer from '@/utils/timer'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { TownName },
  data () {
  // 这里存放数据
    return {
      loading: true,
      isTown: true,
      searchName: '',
      parentAdcdCode: '330324',
      aDDVCD: '',
      type: 'all',
      sID: '22',
      beginTime: '',
      endTime: '',
      categoryOne: [
        { label: '所有站监视', value: '所有站监视' },
        { label: '水库站监视', value: '水库站监视' },
        { label: '江河站监视', value: '江河站监视' },
        { label: '雨量站监视', value: '雨量站监视' }
      ],
      selectCategoryOne: '所有站监视',
      selectCity: '柯桥街道',
      tdata: [],
      hoursOfToday: [],
      hoursOfYesterday: [],
      height: 10,
      currentRow: [],
      cityAll: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      choosed: 0,
      stationName: '',
      inputData: '',
      timerFun: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    sortChange1 (a, b) {
      return a.rainYesterday - b.rainYesterday
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    nameSelect () {
      this.stationName = this.inputData
      this.tabledata()
    },
    searchData () {
      this.stationName = this.inputData
      this.tabledata()
    },
    townAdcd (townAdcd) {
      this.loading = true
      this.aDDVCD = townAdcd
      this.tabledata()
    },
    // 获取数据
    tabledata () {
      if (this.type === 'rain') { // 切换雨量接口
        this.loading = true
        this.$store.dispatch(monitorTypes.GET_SYNTHETICAL_RAIN, {
          sID: this.sID,
          aDDVCD: this.aDDVCD,
          beginTime: this.beginTime,
          endTime: this.endTime,
          stationName: this.stationName,
          mainStation: true
        }).then(data => {
          this.tdata = data.rows
          this.loading = false
        })
      } else {
        this.loading = true
        this.$store.dispatch(monitorTypes.GET_SYNTHETICAL_WATERANDRAIN, {
          aDDVCD: this.aDDVCD,
          type: this.type,
          stationName: this.stationName,
          mainStation: true
        }).then(data => {
          this.tdata = data.rows
          this.loading = false
        })
      }
    },
    // 当前日期 yy-mm-ddd h
    getNowDate () {
      var date = new Date()
      var yy = date.getFullYear()
      var mm = date.getMonth() + 1
      var dd = date.getDate() - 1
      if (mm >= 1 && mm <= 9) {
        mm = '0' + mm
      }
      this.beginTime = yy + '-' + mm + '-' + dd + ' ' + '09:00'
      this.endTime = yy + '-' + mm + '-' + (dd + 1) + ' ' + '09:00'
    },
    // 切换监视站
    categoryChangeOne (index, val) {
      this.loading = true
      this.choosed = index
      switch (val) {
        case '所有监视站':
          this.type = 'all'
          break
        case '水库站监视':
          this.type = 'reservior'
          break
        case '江河站监视':
          this.type = 'river'
          break
        case '雨量站监视':
          this.type = 'rain'
          break
        default:
          this.type = 'all'
          break
      }
      this.tabledata()
    },
    // 选中行数据
    handleCurrentChange (val) {
      this.currentRow = val
    },
    // 切换地区
    getCity (val) {
      this.cityAll.forEach(item => {
        if (val === item.adnm) {
          this.aDDVCD = item.adcd
        }
      })
      this.tabledata()
    },
    // 获取地区
    // adcddata () {
    //   this.$store.dispatch(monitorTypes.GET_ADCD, {
    //     isTown: this.isTown,
    //     searchName: this.searchName,
    //     parentAdcdCode: this.parentAdcdCode,
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize
    //   }).then(data => {
    //     this.cityAll = data.results
    //     console.log(this.cityAll)
    //   })
    // },
    // adcddata () {
    //   let arr = []
    //   this.$store.dispatch(monitorTypes.GET_ADCD, {
    //     isTown: this.isTown,
    //     searchName: this.searchName,
    //     parentAdcdCode: this.parentAdcdCode,
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize
    //   }).then(data => {
    //     this.cityAll = data.total
    //     this.towns = data.results
    //     this.towns.forEach(item => {
    //       let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
    //       obj.adcd = item.adcd
    //       obj.adnm = item.adnm
    //       obj.id = item.id
    //       arr.push(obj)
    //     })
    //     this.towns = arr
    //   })
    // },
    // 保存查询
    submitQuery () {
      this.stationName = this.inputData
      this.tabledata()
    },
    sortHours () {
      let hourList = []
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          i = '0' + i
          hourList.push(i)
        } else {
          hourList.push(i.toString())
        }
      }
      let myDate = new Date()
      let nowHour = myDate.getHours()
      hourList.forEach((item, index) => {
        if (parseInt(item) > 0 && parseInt(item) <= nowHour) {
          this.hoursOfToday.push(item)
        } else {
          this.hoursOfYesterday.push(item)
        }
      })
      this.hoursOfToday.sort((a, b) => {
        return b - a
      })
      this.hoursOfYesterday.splice(0, 1)
      this.hoursOfYesterday.sort((a, b) => {
        return b - a
      })
      this.hoursOfYesterday.unshift('00')
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.sortHours()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.getNowDate()
    // this.adcddata()
    // this.towndata()
    this.tabledata()
    this.timerFun = setInterval(this.searchData, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - countryListDiv[1].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {
    this.$nextTick(() => { // 在数据加载完，重新渲染表格,解决切换表格表头跳动问题
      this.$refs['table'].doLayout()
    })
  }, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    clearInterval(this.timerFun)
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
    .monitor{
      .content{
        .yuliang{
        .select{
          .el-input{
            width: 165px;
           }
          }
        }
      }
    }
</style>
